<template>
	<div class="Notice">
		<div class="header">
			<rs-row>
				<rs-col :span="24" >
					<div class="main_header" style='background-color: #ffffff;display: flex;justify-content: space-between;align-items: center;'>
						<span  class="grid-content bg-purple-dark" >平台公告</span>
						<rs-button @click='$router.back()' style='margin-right:10px ;'>返回</rs-button>
					</div>
					
				<!-- 	<div class="grid-content bg-purple-dark">平台公告</div>
					 <rs-button @click='$router.back()' style='margin-right:10px ;'>返回</rs-button> -->
				</rs-col>
			</rs-row>
			<div class="main">
				<div class="ul" style="border-bottom: 1px solid #ccc">
					<ul v-for="(item, index) in list" :key="item.index">
						<router-link :to="{ path: '/AnnouncementDetail',query: {id:item.id} }">
							<li>
								<div class="p">
									<p style="
                    width: 20px;
                    height: 20px;
                    line-height: 20px;
                    background: #eff4ff;
                    color: #3873ff;
                    text-align: center;
                  ">
										{{ index + 1 }}
									</p>
									<p style="
                    overflow: hidden;
                    width: 80%;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                  ">
				  <span v-if='item.label==""'> </span>
				  <span v-else>【{{item.label}}】</span>
										{{ item.noticeTitle| ellipsis}}
									</p>
								</div>

								<p>{{ item.releaseTime }}</p>
							</li>
						</router-link>
					</ul>
				</div>
				<div class="page" style="
            padding: 20px;
            background: white;
            box-shadow: 2px 5px 10px #909090;
          ">
					<!-- 分页 -->
					<rs-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="pageNum" :page-sizes="[10, 200, 300, 400]" :page-size="pageSize" background
						:prev-text="'上一页'" :next-text="'下一页'" layout="total,prev, pager, next, sizes, jumper"
						:total="total"></rs-pagination>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import API from "@/api/pay";
	import Until from "../../../utils/utils";
	import api from "../../../api/api";
	export default {
		data() {
			return {
				currentPage4: 4,
				pageNum: 1,
				pageSize: 10,
				total: 0,
				list: [],
				gettimes: ''
			};
		},
		created() {
			var _this = this;
			//     let yy = new Date().getFullYear();
			//     let mm =
			//       new Date().getMonth() + 1 < 10
			//         ? "0" + (new Date().getMonth() + 1)
			//         : new Date().getMonth() + 1;
			//     let dd =
			//       new Date().getDate() < 10
			//         ? "0" + new Date().getDate()
			//         : new Date().getDate();
			//     let hh = new Date().getHours();
			//     let mf =
			//       new Date().getMinutes() < 10
			//         ? "0" + new Date().getMinutes()
			//         : new Date().getMinutes();
			//     let ss =
			//       new Date().getSeconds() < 10
			//         ? "0" + new Date().getSeconds()
			//         : new Date().getSeconds();
			_this.gettimes = new Date().getTime()
			console.log(_this.gettimes);
			this.getlist()
		},
		mounted() {
			
		},
		methods: {
			handleSizeChange(val) {
				this.pageSize = val
				this.getlist()
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				this.pageNum = val
				this.getlist()
				console.log(`当前页: ${val}`);
			},
			//获取公告
			getlist() {
				this.list=[]
				let businessId = Until.getSession("shopVo");
				let params = {
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					businessId: businessId
				}
				API.announCement(params).then((res) => {
					console.log(1111,res)
					for (var i in res.data.data.list) {
						console.log(new Date(res.data.data.list[i].releaseTime).getTime() - this.gettimes <= 0)
						if (new Date(res.data.data.list[i].releaseTime).getTime() - this.gettimes <= 0) {
							this.list.push(res.data.data.list[i])
							this.total = res.data.data.total
							console.log(this.list)
						}
					}
				})


			}
		},
		mounted() {},
		filters: {
			//超过50位显示 ...
			ellipsis: function(value) {
				if (!value) return "";
				if (value.length > 50) {
					return value.slice(0, 50) + "......";
				}
				return value;
			}
		}
	};
</script>
<style lang='scss' scoped>
	.Notice {
		height: 100%;
		background-color: #ebebeb;
	}

	.rs-row {
		margin-bottom: 20px;
           
		&:last-child {
			margin-bottom: 0;
		}
	}

	.bg-purple-dark {
		
		color: black;
		font-weight: bold;
		font-size: 15px;
		padding-left: 20px;
	}

	.grid-content {
		/* border-radius: 4px; */
		height: 40px;
		line-height: 40px;
	}

	.main {
		padding: 10px;

	}

	.ul {
		padding: 20px;
		background: white;
		box-shadow: 2px 2px 10px #909090;
		box-sizing: border-box;
	}

	.ul li {
		display: flex;
		justify-content: space-between;
		margin-top: 18px;
	}

	.p {
		display: flex;
		width: 80%;
		font-size: 14x;
	}

	.p p:nth-child(2) {
		margin-left: 15px;
	}

	.p p:nth-child(2):hover {
		cursor: pointer;
		color: #5789ff;
	}
</style>
